import React from 'react'
import Senapatimustardseeds from "../images/Senapati mustard seeds.jpg";
import coriandar from "../images/coraindar.jpg"
import paddyseeds from "../images/paddy seeds pratiksha.jpg";
import paddyseedsbb11 from "../images/paddy seed bb-11.jpg";
import paddyseedsMTU7029 from "../images/PADDY SEEDS MTU 7029.jpg";
import paddyseedssupergold from "../images/Paddy Seeds Super Gold.jpg";
import  paddyseeds25kg from "../images/paddy seeds 25kg.jpg"
import paddyseedsmtu7029 from "../images/paddy seeds 25kg new.jpg";



function Product() {
  return (
    <div>
      
        <div className="container">
    


          <div className="card-section">
            <div className="custom-card">
              <img src={Senapatimustardseeds} className="card-img-top mb-0" alt="Senapatimustardseeds" />


              <h5 className='mb-1'>Mustard (Senapati)</h5>
              <p><small>Net Wt. 900gm</small>
              </p>
              <a className="mb-0 callbutton" href="tel: 6292007000" >Call Enquiry</a>
            </div>

            <div className="custom-card">
                <img src={paddyseeds} className="card-img-top mb-0" alt="paddyseeds" />


              <h5 className='mb-1'>Paddy Seeds (Protiksha)</h5>
              <p><small>Net Wt. 1kg</small>
              </p>
              <a className="mb-0 callbutton" href="tel: 6292007000" >Call Enquiry</a>
            </div>
            <div className="custom-card">
                <img  src={coriandar} className="card-img-top mb-0" alt="coriandar" />


              <h5 className='mb-1'>Coriander (MOROCCAN)</h5>
              <p><small>Net Wt. 1kg</small>
              </p>
              <a className="mb-0 callbutton" href="tel: 6292007000" >Call Enquiry</a>
            </div>
            <div className="custom-card">
                <img src={paddyseedsbb11} className="card-img-top mb-0" alt="paddyseedsbb11" />


              <h5 className='mb-1'>Paddy Seeds BB-11</h5>
              <p><small>Net Wt. 6kg</small>
              </p>
              <a className="mb-0 callbutton" href="tel: 6292007000" >Call Enquiry</a>
            </div>

            <div className="custom-card">
              <img src={paddyseedsMTU7029} className="card-img-top mb-0" alt="paddyseedsMTU7029" />


              <h5 className='mb-1'>Paddy Seeds MTU7029</h5>
              <p><small>Net Wt. 6kg</small>
              </p>
              <a className="mb-0 callbutton" href="tel: 6292007000" >Call Enquiry</a>
            </div>

          

              <div className="custom-card">
              <img src={paddyseedssupergold} className="card-img-top mb-0" alt="Paddy Seeds Super Gold" />


              <h5 className='mb-1'>Paddy Seeds Super Gold</h5>
              <p><small>Net Wt. 6kg</small>
              </p>
              <a className="mb-0 callbutton" href="tel: 6292007000" >Call Enquiry</a>
            </div>

             <div className="custom-card">
              <img src={paddyseeds25kg} className="card-img-top mb-0" alt="Paddy Seeds 25kg" />


              <h5 className='mb-1'>Paddy Seeds BB-11</h5>
              <p><small>Net Wt. 25kg</small>
              </p>
              <a className="mb-0 callbutton" href="tel: 6292007000" >Call Enquiry</a>
            </div>


             <div className="custom-card">
              <img src={paddyseedsmtu7029} className="card-img-top mb-0" alt="paddyseedsmtu7029" />


              <h5 className='mb-1'>Paddy Seeds MTU7029</h5>
              <p><small>Net Wt. 25kg</small>
              </p>
              <a className="mb-0 callbutton" href="tel: 6292007000" >Call Enquiry</a>
            </div>
          </div>

        </div>
      </div>
    
  )
}

export default Product